'use client';
var getElementHeight = function(element) {
    return (element == null ? void 0 : element.current) ? element.current.scrollHeight : "auto";
};

export { getElementHeight };
